import type { TProps } from './models';

export const Pluralize = ({ count = 0, getCorrectSuffix, plurals }: TProps) => {
    return getCorrectSuffix(count, plurals);
};
